//@ts-nocheck

'use client'

import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { ColorSchemeTypes } from '../../../types/ColorScheme'
import { TypographyTypes } from '../../../types/Typography'
import { CtaTypes } from '../../../types/Cta'


import { SectionThemeContext } from '../../../contexts/SectionTheme.context'
import { Col, Container, Row, SpacerBase } from '../../atoms/GridSystem'
import { Heading } from '../../atoms/Typography/Typography.component'
import Button from '../../atoms/Button/Button.component'
import ItemsGrouped from '../../molecules/ItemsGrouped/ItemsGrouped.component'
import CardFeatures from '../../molecules/CardFeatures/CardFeatures.component'
import * as S from './FeatureLists.styles'

type FeatureItem = {
  id: string | number
  [key: string]: any
}

interface FeatureListsProps {
  sectionId?: string
  type: 'FeatureListInformative' | 'FeatureListIconic' | 'FeatureListIllustrative' | 'FeatureListStatistic'
  sectionTitle?: TypographyTypes
  items: FeatureItem[]
  ctaPrimary?: CtaTypes
  ctaSecondary?: CtaTypes
  colorScheme?: ColorSchemeTypes,
  withBackground?: boolean
}

const FeaturesLists: React.FC<FeatureListsProps> = ({
  sectionId,
  type,
  sectionTitle,
  items,
  ctaPrimary,
  ctaSecondary,
  withBackground,
}) => {
  const { selectedColorScheme } = useContext(SectionThemeContext)

  const colLG = items.length > 3 ? 3 : (items.length == 3 ? 4 : (items.length == 2 ? 6 : 3))

  return (
    <S.FeaturesLists colorScheme={selectedColorScheme} as="section" id={sectionId} withBackground={withBackground}>
      <Container>
        {sectionTitle ? (
          <>
            <Heading as={sectionTitle.as} typo={sectionTitle.typo} fontPrimary>
              {sectionTitle.content}
            </Heading>
            <SpacerBase xs={5}/>
          </>
        ) : null}
        {items && items.length > 0 ? (
          <Row>
            {items.map((item, i) => (
              <Col key={`FeaturesLists-${type}-${i}-${item.id}`} xs={12} md={6} lg={colLG} $direction="column" align="flex-start">
                <CardFeatures 
                  {...item} 
                  type={type} 
                  isLast={i === items.length - 1} 
                  colorScheme={selectedColorScheme} 
                  withBackground={withBackground}
                />
              </Col>
            ))}
          </Row>
        ) : null}
        {ctaPrimary || ctaSecondary ? (
          <ItemsGrouped direction={{ xs: "column", md: "row" }} space={{ xs: 16, md: 24 }}>
            {ctaPrimary ? <Button {...ctaPrimary} variant="primary" iconEnd="arrow-right" /> : null}
            {ctaSecondary ? <Button {...ctaSecondary} variant="secondary" iconEnd="arrow-right" /> : null}
          </ItemsGrouped>
        ) : null}
      </Container>
    </S.FeaturesLists>
  )
}

export default FeaturesLists
